import { render } from "./StageTimersBox.vue?vue&type=template&id=6553b1fe&scoped=true"
import script from "./StageTimersBox.vue?vue&type=script&lang=js"
export * from "./StageTimersBox.vue?vue&type=script&lang=js"

import "./StageTimersBox.vue?vue&type=style&index=0&id=6553b1fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6553b1fe"]])

export default __exports__